module.exports = __webpack_public_path__ + "static/media/webinar-pandemi.c7164540.jpeg";